import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettingsSlider1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 9H19M25 9H27M5 23H13M19 23H27M5 16H10M16 16H27",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 22,
			cy: 9,
			r: 3,
			stroke: "currentColor",
			strokeWidth: 1.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13,
			cy: 16,
			r: 3,
			stroke: "currentColor",
			strokeWidth: 1.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 23,
			r: 3,
			stroke: "currentColor",
			strokeWidth: 1.25
		})
	]
});
export default SvgSettingsSlider1;
